import {ApiMethods, ApiResponse, ApiService as Parent} from "../../../@bizkeytech";
import ApiEndpoints from "../../models/api-endpoints";
import {
    GetBlogCategoriesResponse,
    GetBlogPostBySlugResponse,
    SearchBlogPostResponse,
    SearchBlogPostsRequestDs,
    SubmitDemoContactRequest
} from "./type-declarations";

/**
 * The interface that houses all the available api calls related to this application.
 */
class ApiService extends Parent {

    // ########################################     Demo Request    ########################################

    /**
     * Submit a demo contact request.
     *
     * @param request          The request that will be executed.
     * @return {Promise<ApiResponse<void>>}
     */
    public static async submitDemoContact(request: SubmitDemoContactRequest): ApiResponse<void> {
        return await this.executor.execute({
            method: ApiMethods.post,
            url: ApiEndpoints.demoContact.submitADemoRequest,
            data: request,
            showSuccessToast: true,
            showErrorToast: true,
            headers: {
                ExternalApplicationId: "00000000-0000-0000-0000-000000000000",
                TestToken: "00000000-0000-0000-0000-000000000000",
            },
        });
    }

    // ########################################     BLOGS APIS    ########################################

    /**
     * Fetches the categories of the blogs based on the given type.
     *
     * @param type              the type of the blog categories to be fetched
     * @param abortController   the abort controller of the api call
     */
    public static getBlogCategories(type: "Video" | 'Blog', abortController: AbortController): GetBlogCategoriesResponse {
        return this.executor.execute({
            url: ApiEndpoints.blogs.getCategoriesByType(type),
            method: ApiMethods.get,
            signal: abortController.signal,
        })
    }

    /**
     * Searches the blog posts based on the given search criteria.
     * @param request           the search criteria
     * @param abortController   the abort controller of the api call
     */
    public static searchBlogPosts(request: SearchBlogPostsRequestDs, abortController?: AbortController): SearchBlogPostResponse {
        return this.executor.execute({
            url: ApiEndpoints.blogs.searchPosts,
            method: ApiMethods.post,
            data: request,
            signal: abortController?.signal,
        })
    }

    /**
     * Fetches the blog post based on the given slug.
     * @param slug              the slug of the blog post
     * @param abortController   the abort controller of the api call
     */
    public static getBlogPostBySlug(slug: string, abortController: AbortController): GetBlogPostBySlugResponse {
        return this.executor.execute({
            url: ApiEndpoints.blogs.getPostBySlug(slug),
            method: ApiMethods.get,
            signal: abortController.signal,
        })
    }

}


export * from './type-declarations';
export default ApiService;
